// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"2b30be42","144":"81a313cb","785":"ab88b143","825":"64aac6f9"}[chunkId] + ".chunk.css";
};